import { useI18n } from '@/hooks/useI18n';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { HeroStarburst } from '@/components/primitives/GradientHero';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <HeroStarburst className="h-24 w-24" />
      <div className="text-[12px] font-semibold uppercase tracking-[0.18em] text-violet-deep">
        404 · not found
      </div>
      <h1 className="font-display text-[40px] tracking-tight text-text-1">
        Page <span className="violet-gradient-text">{t('introuvable', 'not found')}</span>
      </h1>
      <p className="max-w-md text-[14px] text-text-3">
        {t(
          "L'URL ne correspond à aucune section. Utilisez la navigation latérale ou la palette ⌘F.",
          'This URL does not match any section. Use the sidebar or the ⌘K command palette.',
        )}
      </p>
      <Button asChild variant="primary" size="lg" className="mt-2">
        <Link to="/">{t('Retour au dashboard →', 'Back to dashboard →')}</Link>
      </Button>
    </div>
  );
}
